import { forwardRef, useEffect, useState } from "react";
import { ContentState, Editor } from 'react-draft-wysiwyg';
import { EditorState, convertFromRaw, convertToRaw } from 'draft-js';
import { convertToHTML } from "draft-convert";
import htmlToDraft from 'html-to-draftjs';
import '../../../../../../../node_modules/react-draft-wysiwyg/dist/react-draft-wysiwyg.css';

const RichTextField = forwardRef((props, ref) => {
    let className = '';

    const contentStateToEditorState = (contentState) => {
        try {
            if (contentState) {
                if (contentState.blocks && contentState.entityMap !== undefined) {
                    const contentStateObj = convertFromRaw(contentState);
                    const editorState = EditorState.createWithContent(contentStateObj);
                    return editorState;
                } else if (contentState.html) {
                    const contentBlock = htmlToDraft(contentState.html);
                    const contentStateObj = ContentState.createFromBlockArray(contentBlock.contentBlocks);
                    const editorState = EditorState.createWithContent(contentStateObj);
                    return editorState;
                } else {
                    console.error("Invalid contentState format", contentState);
                }
            }
        } catch (error) {
            console.error("Error converting contentState to EditorState", error, contentState);
        }
        return EditorState.createEmpty();
    };

    const handleEditorStateChange = (editorState) => {
        setEditorState(editorState);
        const contentState = convertToRaw(editorState.getCurrentContent());
        handleChange(contentState);
    };

    const handleChange = (content) => {
        const html = convertToHTML({
            blockToHTML: (block) => {
                const textAlignment = block.data['text-align'] || 'left';


                switch (block.type) {
                    case 'header-one':
                        return <h1 style={{ textAlign: textAlignment }} />;
                    case 'header-two':
                        return <h2 style={{ textAlign: textAlignment }} />;
                    case 'header-three':
                        return <h3 style={{ textAlign: textAlignment }} />;
                    case 'header-four':
                        return <h4 style={{ textAlign: textAlignment }} />;
                    case 'header-five':
                        return <h5 style={{ textAlign: textAlignment }} />;
                    case 'header-six':
                        return <h6 style={{ textAlign: textAlignment }} />;
                    case 'blockquote':
                        return <blockquote style={{ textAlign: textAlignment }} />;
                    case 'code-block':
                        return <pre style={{ textAlign: textAlignment }} />;
                    case 'unordered-list-item':
                        return <li style={{ textAlign: textAlignment }} />;
                    case 'ordered-list-item':
                        return {
                            nest: <ol />,
                            element: <li style={{ textAlign: textAlignment }} />
                        };
                    default:
                        return <div style={{ textAlign: textAlignment }} />;
                }
            },
            styleToHTML: (style) => {
                if (style === 'BOLD') return <strong />;
                if (style === 'ITALIC') return <em />;
                if (style === 'UNDERLINE') return <u />;
            },

        })(editorState.getCurrentContent());

        const target = {
            name: props.name,
            value: { ...content, html },
        };


        props.onChange({ target });
    };

    if (props.error) {
        className = "is-invalid";
    }

    const [editorState, setEditorState] = useState(props.value ? contentStateToEditorState(props.value) : EditorState.createEmpty());

    return (
        <div ref={ref}>
            <Editor
                editorState={editorState}
                ref={ref}
                wrapperClassName="demo-wrapper"
                editorClassName={"demo-editor pr-3 pl-3" + className}
                onEditorStateChange={handleEditorStateChange}
                readOnly={props.readOnly}
                toolbar={{
                    options: ['inline', 'blockType', 'list', 'textAlign'],
                    inline: {
                        options: ['bold', 'italic', 'underline'],
                    },
                    list: {
                        options: ['unordered', 'ordered'],
                    },
                    blockType: {
                        inDropdown: true,
                    },
                }}
            />
            {props.error && (
                <span
                    className="error invalid-feedback"
                    style={{ display: 'inline' }}>
                    {props.error}
                </span>
            )}
        </div>
    );
});

export default RichTextField;
